import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["width", "height", "viewBox", "fill"]
const _hoisted_2 = { "clip-path": "url(#clip0_11969_54524)" }
const _hoisted_3 = ["fill"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_11969_54524" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "10",
      height: "10",
      fill: "white",
      transform: "translate(0 0.00390625)"
    })
  ])
], -1)
const _hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_11969_50658)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M-0.00390625 0.640904C-0.00390625 0.285863 0.28391 -0.00195312 0.638951 -0.00195312H3.11148C3.12756 -0.00195312 3.14351 -0.00136231 3.1593 -0.00020121H8.83435C8.84969 -0.00131349 8.86521 -0.00187526 8.88072 -0.00187526H11.3532C11.7083 -0.00187526 11.9961 0.285942 11.9961 0.640982V3.11383C11.9961 4.70748 10.7995 6.02165 9.25572 6.20687C8.87224 7.38047 7.87256 8.27537 6.63895 8.50938V10.7124H8.88072C9.23575 10.7124 9.52358 11.0002 9.52358 11.3553C9.52358 11.7103 9.23575 11.9981 8.88072 11.9981H6.0186C6.01113 11.9984 6.00363 11.9985 5.99609 11.9985C5.98856 11.9985 5.98106 11.9984 5.97359 11.9981H3.11147C2.75644 11.9981 2.46862 11.7103 2.46862 11.3553C2.46862 11.0002 2.75644 10.7124 3.11147 10.7124H5.35324V8.50938C4.11963 8.27537 3.11996 7.38047 2.73644 6.20687C1.1927 6.02165 -0.00390625 4.70748 -0.00390625 3.11383V0.640904ZM2.46863 4.82738V1.28376H1.28181V3.11383C1.28181 3.89811 1.77526 4.56713 2.46863 4.82738ZM9.52358 1.28384V4.82738C10.2169 4.56713 10.7104 3.89811 10.7104 3.11383V1.28384H9.52358Z",
    fill: "#211F58"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_11969_50658" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "12",
      height: "12",
      fill: "white"
    })
  ])
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'scoreIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#878787",
  },
  width: {
    type: Number as PropType<number>,
    default: 10,
  },
  height: {
    type: Number as PropType<number>,
    default: 10,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.width !== 12)
      ? (_openBlock(), _createElementBlock("svg", {
          key: 0,
          width: __props.width,
          height: __props.height,
          viewBox: `0 0 ${__props.width} ${__props.height}`,
          fill: __props.color,
          xmlns: "http://www.w3.org/2000/svg"
        }, [
          _createElementVNode("g", _hoisted_2, [
            _createElementVNode("path", {
              "fill-rule": "evenodd",
              "clip-rule": "evenodd",
              d: "M-0.00195312 0.539621C-0.00195312 0.243753 0.237894 0.00390625 0.533761 0.00390625H2.5942C2.6076 0.00390625 2.6209 0.00439859 2.63405 0.00536618H7.36326C7.37605 0.00443928 7.38898 0.00397113 7.4019 0.00397113H9.46233C9.75819 0.00397113 9.99805 0.243818 9.99805 0.539685V2.60039C9.99805 3.92843 9.0009 5.02358 7.7144 5.17793C7.39483 6.15593 6.56177 6.90168 5.53376 7.09668V8.93255H7.4019C7.69776 8.93255 7.93762 9.17241 7.93762 9.46826C7.93762 9.76412 7.69776 10.004 7.4019 10.004H5.0168C5.01058 10.0042 5.00433 10.0043 4.99805 10.0043C4.99177 10.0043 4.98552 10.0042 4.97929 10.004H2.5942C2.29833 10.004 2.05848 9.76412 2.05848 9.46826C2.05848 9.17241 2.29833 8.93255 2.5942 8.93255H4.46233V7.09668C3.43433 6.90168 2.60127 6.15593 2.28167 5.17793C0.995218 5.02358 -0.00195312 3.92843 -0.00195312 2.60039V0.539621ZM2.05849 4.02835V1.07533H1.06948V2.60039C1.06948 3.25396 1.48068 3.81148 2.05849 4.02835ZM7.93762 1.0754V4.02835C8.5154 3.81148 8.92662 3.25396 8.92662 2.60039V1.0754H7.93762Z",
              fill: __props.color
            }, null, 8, _hoisted_3)
          ]),
          _hoisted_4
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (__props.width === 12)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_8))
      : _createCommentVNode("", true)
  ], 64))
}
}

})